export default __webpack_public_path__ + "static/media/photosave.0c220ef1.png";